import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { MODALS } from 'src/models/ModalModel';
import { openModal } from 'src/redux/actions/modalActions';
import { Store, useAppDispatch } from 'src/redux/Store';
import { useSelector } from 'react-redux';
import { t } from 'src/lib/language';
import { useEffect } from 'react';
import { setSelections } from 'src/redux/actions/selectionActions';
import { ENTITIES } from 'src/models/QuerybuilderModel';
import AttachMoneyOutlinedIcon from '@material-ui/icons/AttachMoneyOutlined';

interface Props {
  paymentId?: string | number;
}

const ShowPaymentTransactionButton = (props: ButtonProps & Props) => {
  const dispatch = useAppDispatch();
  const { disabled } = props;
  const lang = useSelector((state: Store) => state.language.language);
  const { paymentId } = props;

  useEffect(() => {
    if (paymentId) {
      dispatch(setSelections({
        entity: ENTITIES.payments,
        selections: [paymentId],
      }));
    }
  }, []);

  const handleOpen = () => {
    dispatch(openModal({ modal: MODALS.editPayment }));
  };

  return (
    <>
      <Tooltip
        title={t(lang, 'menus.show_transaction_payment')}
        placement="top-start">
        <span>
          <ActionButton
            variant="outlined"
            category={MENU_BUTTON_CATEGORY.action}
            onClick={handleOpen}
            disabled={disabled}>
            <AttachMoneyOutlinedIcon />
          </ActionButton>
        </span>
      </Tooltip>
    </>
  );
};

export default ShowPaymentTransactionButton;
